import * as XLSX from 'xlsx';
import { TFunction } from 'i18next';
import moment from 'moment';
import {
    SOURCE_OF_HIRE_DISTRIBUTION_METRICS,
    SourceOfHireDistributionMetric,
} from '../consts/reports.consts';
import {
    IClientSourceOfHireEntry,
    ISourceOfHireStageBar,
} from '../interfaces/reports.interfaces';
import { formatSourceOfHireAmount } from './reports.utils';

const sanitizeFileName = (value: string): string =>
    value.replace(/[\\/:*?"<>|]/g, '_').trim() || 'export';

const today = (): string => moment().format('YYYY-MM-DD');

export const exportSourceOfHireDistributionToExcel = (
    entries: IClientSourceOfHireEntry[],
    metric: SourceOfHireDistributionMetric,
    t: TFunction
): void => {
    const sourceHeader = t('reportsPage.sourceOfHireReport.source');
    const shareHeader = t('reportsPage.sourceOfHireReport.share');
    const metricOption = SOURCE_OF_HIRE_DISTRIBUTION_METRICS.find(
        (option) => option.metric === metric
    );
    const metricLabel = metricOption ? t(metricOption.labelKey) : metric;
    const isPercent = metricOption?.isPercent ?? false;

    const rows = [
        [metricLabel],
        [sourceHeader, shareHeader],
        ...entries.map((entry) => [
            entry.sourceTitle,
            formatSourceOfHireAmount(entry.amount, isPercent),
        ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Source of Hire');
    XLSX.writeFile(
        workbook,
        `source-of-hire_${sanitizeFileName(metric)}_${today()}.xlsx`
    );
};

export const exportSourceOfHireStagesToExcel = (
    bars: ISourceOfHireStageBar[],
    sourceTitle: string,
    t: TFunction
): void => {
    const sourceHeader = t('reportsPage.sourceOfHireReport.source');
    const stageHeader = t('reportsPage.sourceOfHireReport.stageColumnLabel');
    const valueHeader = t('reportsPage.sourceOfHireReport.valueColumnLabel');
    const totalHeader = t('reportsPage.sourceOfHireReport.stageTotalLabel');

    const rows = [
        [sourceHeader, sourceTitle],
        [stageHeader, valueHeader, totalHeader],
        ...bars.map((bar) => [bar.name, bar.value, bar.total]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Source of Hire');
    XLSX.writeFile(
        workbook,
        `source-of-hire_${sanitizeFileName(sourceTitle)}_${today()}.xlsx`
    );
};
